import {type PropsWithChildren, useRef} from 'react'
import {Box} from '@primer/react'
import {testIdProps} from '@github-ui/test-id-props'
import {useActionBarResize} from './ActionBarResizeContext'
import useIsomorphicLayoutEffect from '@primer/react/lib-esm/utils/useIsomorphicLayoutEffect'

type VisibleItemProps = PropsWithChildren<{actionKey: string}>

export const VisibleItem = ({children, actionKey: key}: VisibleItemProps) => {
  const itemRef = useRef<HTMLDivElement>(null)
  const {recalculateItemSize} = useActionBarResize()

  useIsomorphicLayoutEffect(() => {
    if (itemRef.current) recalculateItemSize(key, itemRef.current)
  }, [itemRef, recalculateItemSize, key])

  return (
    <Box {...testIdProps(`action-bar-item-${key}`)} sx={{display: 'inline-flex'}} ref={itemRef}>
      {children}
    </Box>
  )
}

try{ VisibleItem.displayName ||= 'VisibleItem' } catch {}